"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Handle = void 0;

var _react = _interopRequireDefault(require("react"));

var _rcSlider = _interopRequireDefault(require("rc-slider"));

var _classnames = _interopRequireDefault(require("classnames"));

var _enhanceFormControl = _interopRequireDefault(require("./enhance-form-control"));

require("rc-slider/assets/index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var className = function className(props) {
  return (0, _classnames.default)('Slider', {
    'Slider--hide-marks': props.hideMarks,
    'Slider--hide-steps': props.hideSteps
  }, {
    'Slider--alt': props.variation === 'alt'
  }, props.className);
};

var Handle = function Handle(props) {
  var value = props.value,
      offset = props.offset;
  return _react.default.createElement("div", {
    className: "Slider__handle",
    style: {
      left: offset + '%'
    }
  }, _react.default.createElement("div", {
    className: "Slider__tooltip"
  }, value));
};

exports.Handle = Handle;

var Slider = function Slider(props) {
  var handle = props.handle,
      style = props.style;
  return _react.default.createElement(_rcSlider.default, _extends({}, props, {
    className: className(props),
    style: style,
    handle: handle
  }));
};

var _default = (0, _enhanceFormControl.default)(Slider);

exports.default = _default;